import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query'

interface IUseQueryHookProps<T> {
  key: string | Array<string>
  fetcherFunction: (...args: any[]) => Promise<T>
  options?: Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>
}

export function useQueryHook<T>({ key, fetcherFunction, options }: IUseQueryHookProps<T>): UseQueryResult<T> {
  const queryObject = useQuery<T>({
    queryKey: Array.isArray(key) ? key : [key],
    queryFn: fetcherFunction,
    retry: 0,
    ...options,
  })

  return queryObject
}
